<template>
  <div>
    <span class="main-header__offcanvas__close" @click="onClose"></span>
    <div class="main-header__account__media">
      <div class="main-header__account__holder-img">
        <app-avatar block :name="fullName" :url="avatarUrl" />
      </div>
      <div class="main-header__account__media-details">
        <p>{{ "account.hello" | trans }},</p>
        <p>{{ fullName }}</p>
      </div>
    </div>

    <ul class="main-header__account__holder-links">
      <li class="main-header__account__list-link">
        <app-website-link path="/account/" class="main-header__account__link">
          <i class="main-header__account__icon-link icon-edit"></i>
          {{ "account.menu.info" | trans }}
        </app-website-link>
      </li>
      <li class="main-header__account__list-link">
        <app-website-link
          path="/account/addresses"
          class="main-header__account__link"
        >
          <i class="main-header__account__icon-link icon-signboard"></i>
          {{ "account.menu.addresses" | trans }}
        </app-website-link>
      </li>
      <li class="main-header__account__list-link">
        <app-website-link
          path="/account/orders/"
          class="main-header__account__link"
        >
          <i
            class="main-header__account__icon-link icon-cube-of-notes-stack"
          ></i>
          {{ "account.menu.order_history" | trans }}
        </app-website-link>
      </li>
      <li class="main-header__account__list-link">
        <app-website-link
          path="/account/tickets/"
          class="main-header__account__link"
        >
          <i class="main-header__account__icon-link icon-file"></i>
          {{ "account.menu.tickets" | trans }}
        </app-website-link>
      </li>
      <li class="main-header__account__list-link">
        <app-website-link
          path="/account/wishlist/"
          class="main-header__account__link"
        >
          <i class="main-header__account__icon-link icon-heart-outline"></i>
          {{ "account.menu.wishlist" | trans }}
        </app-website-link>
      </li>
      <li class="main-header__account__list-link">
        <b-link class="main-header__account__link" @click="onLogout">
          <i class="main-header__account__icon-link icon-logout"></i>
          {{ "account.menu.logout" | trans }}
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import AppWebsiteLink from "@/components/ui/WebsiteLink";
import AppAvatar from "@/components/user/Avatar";

export default {
  name: "AppAccount",
  components: { AppAvatar, AppWebsiteLink },
  props: {
    fullName: {
      type: String,
      required: true,
      default: "",
    },
    avatarUrl: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    onLogout() {
      this.$emit("logout");
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
